import React, { useState, useEffect, useRef } from 'react';
import styles from './Schedule.module.css';
import iconIglesia from '../../assets/icon-iglesia.png';
import iconRecepcion from '../../assets/icon-recepcion.png';
import iconCena from '../../assets/icon-cena.png';
import iconVals from '../../assets/icon-vals.png';
import iconDance from '../../assets/icon-dance.png';

const Schedule: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const sectionRef = useRef<HTMLDivElement>(null);
  const itemRefs = useRef<(HTMLDivElement | null)[]>([]);

 useEffect(() => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    },
    {
      threshold: 0.1,
      rootMargin: '50px'
    }
  );

  const currentRef = sectionRef.current;

  if (currentRef) {
    observer.observe(currentRef);
  }

  return () => {
    if (currentRef) {
      observer.unobserve(currentRef);
    }
  };
}, []);

 useEffect(() => {
  const currentItems = itemRefs.current;

  const observers = currentItems.map((ref, index) => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setActiveIndex(index);
        }
      },
      {
        threshold: 0.6,
        rootMargin: '-20% 0px -20% 0px'
      }
    );

    if (ref) {
      observer.observe(ref);
    }

    return observer;
  });

  return () => {
    observers.forEach((observer, index) => {
      if (currentItems[index]) {
        observer.unobserve(currentItems[index]!);
      }
    });
  };
}, [isVisible]);

  const scheduleItems = [
    {
      time: '16:00 HRS',
      title: 'Ceremonia Religiosa',
      description: 'Parroquia de San Miguel Arcángel',
      icon: iconIglesia,
      large: false
    },
    {
      time: '18:00 HRS',
      title: 'Recepción',
      description: 'Salón Villa Caro',
      icon: iconRecepcion,
      large: true
    },
    {
      time: '18:30 HRS',
      title: 'Comida',
      description: '',
      icon: iconCena,
      large: false
    },
    {
      time: '20:00 HRS',
      title: 'Vals',
      description: '',
      icon: iconVals,
      large: true
    },
    {
      time: '21:00 HRS',
      title: 'Baile',
      description: '',
      icon: iconDance,
      large: false
    }
  ];

  return (
    <section className={styles.schedule} ref={sectionRef}>
      <div className={styles.scheduleContent}>
        <div className="container">
          <h3 className={styles.sectionTitle}>
            Te compartimos los detalles<br />
            de la celebración
          </h3>
          
          <div className={styles.scheduleTimeline}>
            <div className={`${styles.timelineLine} ${isVisible ? styles.animate : ''}`}></div>
            
            {scheduleItems.map((item, index) => (
              <div 
                key={index}
                ref={(el) => (itemRefs.current[index] = el)}
                className={`${styles.scheduleItem} ${isVisible ? styles.fadeIn : ''} ${activeIndex === index ? styles.active : ''}`}
              >
                <div className={styles.scheduleCircle}>♡</div>
                
                <div className={styles.scheduleTime}>{item.time}</div>
                
                <div className={styles.scheduleDetails}>
                  <h4>{item.title}</h4>
                  {item.description && <p>{item.description}</p>}
                </div>
                
                <div className={`${styles.scheduleIconLarge} ${item.large ? styles.large : ''}`}>
                  <img src={item.icon} alt={item.title} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Schedule;